export const FORUM_SESSION_KEY = 'forum-session';
export const FORUM_POSTS_CACHE_KEY = 'forum-posts-cache';
export const FORUM_SESSION_EVENT = 'forum-session-change';
export const FORUM_SESSION_EXPIRED_EVENT = 'forum-session-expired';

const isBrowser = () => typeof window !== 'undefined';

export const notifyForumSessionChange = () => {
  if (!isBrowser()) return;
  window.dispatchEvent(new Event(FORUM_SESSION_EVENT));
};

export const clearStoredForumSession = () => {
  if (!isBrowser()) return;
  window.localStorage.removeItem(FORUM_SESSION_KEY);
  notifyForumSessionChange();
};

export const notifyForumSessionExpired = () => {
  if (!isBrowser()) return;
  window.dispatchEvent(new Event(FORUM_SESSION_EXPIRED_EVENT));
};
